import { sanitizeSensorId } from 'features/timeSeries/utils/dataProcessing'
import { TimeSeriesDerivedValueEntryJSON } from 'types'

const USER_DERIVED_ID = /^derived_\d+$/

/**
 * Derived values a person built with the formula form. Agent, model,
 * regression and chat-computed pens share the derived-value list but are
 * owned by the surface that made them, so they are not editable here.
 */
export const isUserDerivedTag = (
  derived: Pick<TimeSeriesDerivedValueEntryJSON, 'id'>
): boolean => USER_DERIVED_ID.test(derived.id)

/** The stored expression with each sanitized tag id swapped for its name. */
export const readableDerivedExpression = (
  derived: Pick<TimeSeriesDerivedValueEntryJSON, 'data'>,
  nameOf: (id: string) => string
): string =>
  [...derived.data.dependencyIds]
    .sort((a, b) => b.length - a.length)
    .reduce(
      (expression, id) =>
        expression.replaceAll(sanitizeSensorId(id), nameOf(id)),
      derived.data.expression
    )
